import React, { useEffect, useState } from 'react';
import './pricingTabs.scss';
import { TabView, TabPanel } from 'primereact/tabview';
import PropTypes from 'prop-types';

import FrontPricing from './FrontPricing';

export default function Tabs({ history }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const navegationState = history.location.state;

  useEffect(() => {
    if (navegationState) {
      setActiveIndex(navegationState.data);
    }
  }, [history]);

  const tabHeaderFrontTemplate = options => {
    return (
      <div
        className="p-d-flex text-left p-px-3"
        style={{ cursor: 'pointer', padding: '20px' }}
        onClick={options.onClick}
        onKeyUp={options.handleKeyUp}
        role="button"
        tabIndex={0}>
        <span className="tab--title">UPshow CONNECT Pricing</span>
        <p className="tab--subtitle">Customer Experience</p>
      </div>
    );
  };

  return (
    <div className="pricingTabs--container">
      <TabView activeIndex={activeIndex} onTabChange={e => setActiveIndex(e.index)}>
        <TabPanel headerTemplate={tabHeaderFrontTemplate}>
          <FrontPricing />
        </TabPanel>
      </TabView>
    </div>
  );
}

Tabs.propTypes = {
  history: PropTypes.any.isRequired,
};
